import { requestHandler } from '../utils/api';

export type Meta = {
  title: string;
  description?: string;
  image?: string;
  icon?: string;
  category?: string;
};

export const fetchMeta = async (url: string, apiUrl: string): Promise<Meta> => {
  const { data } = await requestHandler({
    url: `${apiUrl}/meta/scrap?url=${encodeURIComponent(url)}`,
    withCredentials: false,
  });

  return data;
};
